module.exports = __webpack_public_path__ + "img/矩形 1456.b744fb51.png";